/* eslint-disable @atlaskit/design-system/use-tokens-typography */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var containerStyles = css({
  alignItems: 'center',
  display: 'flex',
  gap: "var(--ds-space-100, 8px)",
  justifyContent: 'space-between',
  // AK ModalBody has 2px padding top and bottom.
  // Using 14px here to create 16px gap between
  // link info and iframe
  padding: "var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-300, 24px)", " 14px ", "var(--ds-space-300, 24px)")
});
var iconSize = '24px';
// EDM-7328: CSS Specificity
// An embed modal icon css for img, span, svg has specificity weight of 0-1-1.
// Specify flex ui icon selector to increase specificity weight to 0-2-1.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var iconCss = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&, [data-smart-element-icon] img, [data-smart-element-icon] span, [data-smart-element-icon] svg, img, span, svg': {
    height: iconSize,
    minHeight: iconSize,
    maxHeight: iconSize,
    width: iconSize,
    minWidth: iconSize,
    maxWidth: iconSize
  }
});
var height = '20px';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var titleCss = css({
  flex: '1 1 auto',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  h3: {
    flex: '1 1 auto',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: '-webkit-box',
    marginBottom: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    '@supports not (-webkit-line-clamp: 1)': {
      maxHeight: height
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var actionCss = css({
  display: 'flex',
  flex: '0 0 auto',
  gap: "var(--ds-space-050, 4px)",
  lineHeight: height,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  span: {
    lineHeight: height
  },
  '@media only screen and (max-width: 980px)': {
    // Hide resize button if the screen is smaller than the min width
    // or too small to have enough impact to matter.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.smart-link-resize-button': {
      display: 'none'
    }
  }
});